
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"12px","height":"20px","viewBox":"0 0 12 20","version":"1.1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}, attrs),
              ...rest,
            },
            children.concat([_c('title',[_v('Chevron')]),_c('g',{attrs:{"id":"Templates---iPhone---Tabbed-App","stroke":"none","stroke-width":"1","fill":"none","fill-rule":"evenodd"}},[_c('g',{attrs:{"id":"Artboard","fill":"#FFFFFF","fill-rule":"nonzero"}},[_c('g',{attrs:{"id":"Chevron","transform":"translate(0.327667, 0.732773)"}},[_c('path',{attrs:{"d":"M0,9.5113678 C0,9.69465637 0.0342686971,9.86541239 0.102806091,10.0236359 C0.171343486,10.1818593 0.278065999,10.3321381 0.422973633,10.474472 L8.7958374,18.6616974 C9.03776042,18.9037323 9.33020528,19.0247498 9.673172,19.0247498 C9.90804545,19.0247498 10.1198959,18.9693044 10.3087234,18.8584137 C10.497551,18.747523 10.6491725,18.5983073 10.763588,18.4107666 C10.8780034,18.2232259 10.9352112,18.0127462 10.9352112,17.7793274 C10.9352112,17.438151 10.8057454,17.1364746 10.546814,16.8742981 L2.99824524,9.50935364 L10.546814,2.1484375 C10.8057454,1.88883464 10.9352112,1.58782959 10.9352112,1.24542236 C10.9352112,1.01200358 10.8780034,0.801523844 10.763588,0.613983154 C10.6491725,0.426442464 10.497551,0.277226766 10.3087234,0.16633606 C10.1198959,0.0554453532 9.90804545,0 9.673172,0 C9.33020528,0 9.03776042,0.118052165 8.7958374,0.354156494 L0.422973633,8.54826355 C0.279408773,8.69059753 0.173357646,8.84054057 0.104820251,8.99809265 C0.0362828573,9.15564473 0.00134277344,9.32673645 0,9.5113678 Z","id":"Path"}})])])])])
          )
        }
      }
    